var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrapRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.332,
    height: 8,
    viewBox: "0 0 7.332 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9676",
    "data-name": "Trac\\xE9 9676",
    d: "M26.832,0H23.166a1.835,1.835,0,0,0-1.833,1.833v4.99a1.166,1.166,0,0,0,2.014.8L24.984,5.89l1.671,1.75a1.166,1.166,0,0,0,2.01-.8v-5A1.835,1.835,0,0,0,26.832,0Z",
    transform: "translate(-21.333)",
    fill: "#ba0e67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapRed);
export default __webpack_public_path__ + "static/media/drapRed.fe124c857bfb672b3653e99ae80b6390.svg";
export { ForwardRef as ReactComponent };